import React from 'react';
import {useTranslation} from 'react-i18next';
import Information from '../../common/component/Information';

function Imprint() {

    //TODO
    const [t] = useTranslation();
    const text = (
        <>
            <p>Lorem ipsum dolor sit amet:</p>
            <p className="font-weight-bold">Lorem ipsum dolor sit amet</p>
            <p>sed diam nonumy eirmod tempor invidunt</p>
            <br/>
            <p>Email: <a href="mailto:info@zwergerlkoch.de">Lorem ipsum dolor sit amet</a></p>
            <p>Web: <a href="https://www.albrechthof.de" target="_blank">Lorem ipsum dolor sit amet</a></p>
            <br/>
        </>);

    return (
        <Information header={t('General.IMPRINT')} content={text}/>
    );
}

export default Imprint;
